import styled from 'styled-components';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  display: flex;
  font-family: ${Font.Family.SANS};
  flex-direction: column;
  margin: ${Spacing.SINGLE_HALF} 0;

  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

export const HeaderContainer = styled.div`
  margin-bottom: ${Spacing.QUARTER};
`;

/**
 * @deprecated The shef-web design system is being retired. Use `components/Input`
 *   from `web-common/src/shared/design-system` instead.
 * @see https://app.asana.com/0/0/1218340209270973
 */
export const Header = styled.div`
  align-items: center;
  color: ${Colors.GRAY_DARK_30};
  display: flex;
  font-size: ${Font.Size.S};
  font-weight: 600;
  gap: ${Spacing.HALF};
`;

export const SubHeader = styled.div`
  color: ${Colors.GRAY_DARK_10};
  font-size: ${Font.Size.XS};
`;

export const FooterContainer = styled.div`
  margin-top: ${Spacing.QUARTER};
`;

export const Footer = styled.div`
  color: ${Colors.GRAY_DARK_10};
  font-size: ${Font.Size.XS};
`;
